module.exports = __webpack_public_path__ + "static/logo-15287549cdd743c0126e38bc1a18f3ff.png";